import React from "react";
import { AccountStateEnum, IAuthContextType } from "./types";

export const AuthContext = React.createContext<IAuthContextType>({
  authInfoList: {},
  accountSigningKeyState: AccountStateEnum.REQUIRE_CONNECT,
  accountApiKeyState: AccountStateEnum.REQUIRE_CONNECT,
  manualImportAccount: () => undefined,
  manualSyncAccount: () => undefined,
  isGeoblocked: undefined,
  getRawAccountAuthInfo: () => undefined,
  getImportedAccountAddress: () => null,
  account: undefined,
  masterAccount: undefined,
  activeSubaccount: undefined,
  setActiveSubaccount: () => undefined,
  isAccountImported: false,
  apiKey: undefined,
  apiSecret: undefined,
  signingKey: undefined,
  expiry: undefined,
  showInvalidRefModal: false,
  isEncryptionEnabled: false,

  setAuthInfoList: () => null,
  encryptAccount: () => false,
  reconnectImportedAccount: () => undefined,
  unlockAccount: () => false,
  disconnectAccount: () => false,
  enableTrading: () => null,
  deleteAuthInfo: () => null,
  setShowInvalidRefModal: () => null,
});
